import { Box, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import variables from "../../../assets/styles/variables.module.scss";
import CloseIcon from "@mui/icons-material/Close";

const FormView = () => {
  const [expanded, setExpanded] = useState<string>(""); // Track expanded panel
  const handleCancel = () => {
    setExpanded(""); // Reset expanded state
  };

  return (
    <Box
      sx={{
        "&::before": {
          content: '""',
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 7,
        },
      }}
    >
      <Box
        sx={{
          width: "500px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          pt: "10px",
          position: "fixed",
          right: "0",
          top: "0",
          height: "100vh",
          background: variables.whiteColor,
          padding: "20px 30px",
          zIndex: 8,
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: "100%",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Sharepoint
              </Typography>
              <IconButton aria-label="close" onClick={handleCancel}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                mb: 1,
              }}
            >
              <Typography variant="body2">
                Name
              </Typography>
              <Typography variant="subtitle2">
                Demo SharePoint Config
              </Typography>
            </Box>
            <Box
              sx={{
                mb: 1,
              }}
            >
              <Typography variant="body2">
                Name
              </Typography>
              <Typography variant="subtitle2">
                Demo SharePoint Config
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FormView;
